import React from 'react'
import { PrismicRichText } from '@prismicio/react'

const Faq = ({ slice }) => {
  const summaryClass =
    'flex cursor-pointer rounded-md p-4 text-orange-500 outline-none ring-inset hover:text-orange-600 focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 text-xl leading-snug tracking-tight font-medium'

  return (
    <section itemScope itemType='https://schema.org/FAQPage' className={`component-faq relative mx-auto max-w-screen-xl py-3 px-4`}>
      <div className='prose prose-blue min-w-full'>
        {slice.primary.faq_title && <h2>{slice.primary.faq_title}</h2>}
        {slice.primary.text.richText && <PrismicRichText field={slice.primary.text.richText} />}
        {slice.primary.faq_text && <div>{slice.primary.faq_text}</div>}
      </div>
      <ul className='mt-3'>
        {slice.items.map((faq, index) => {
          return (
            <li key={`faq-${index}`} itemScope itemProp='mainEntity' itemType='https://schema.org/Question'>
              <details className='mb-2 overflow-hidden rounded-md bg-white shadow-sm md:mb-3' open>
                <summary className={summaryClass}>
                  <div className='m-0 flex-1' itemProp='name'>
                    {faq.question}
                  </div>
                  <div className='indicator float-right flex'>
                    <svg xmlns='http://www.w3.org/2000/svg' className='h-6 w-6' viewBox='0 0 24 24' fill='currentColor'>
                      <path d='M0 0h24v24H0V0z' fill='none'></path>
                      <path d='M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z'></path>
                    </svg>
                  </div>
                </summary>
                <div className='p-4 pt-0' itemScope itemProp='acceptedAnswer' itemType='https://schema.org/Answer'>
                  <div itemProp='text' className='prose prose-blue min-w-full'>
                    <PrismicRichText field={faq.answer.richText} />
                  </div>
                </div>
              </details>
            </li>
          )
        })}
      </ul>
    </section>
  )
}

export default Faq
